<script setup>
const props = defineProps({
    message: String,
    backgroundColor: {
        type: Boolean,
        required: false,
        default: true
    }
});
import utilHelper from "../../app/utilHelper";
const {getSanitizeHtml} = utilHelper();

</script>

<template>
    <div v-if="message" class="guidance uk-margin-small-bottom" :class="{'uk-background-muted' : backgroundColor}"><div v-html="getSanitizeHtml(message)"></div></div>
</template>

<style scoped>
    .guidance {
        padding: 20px;
        border-radius: 15px;
        white-space: pre-wrap;
        text-align: left !important;
    }

</style>